import { Container } from './styles'
import { Button } from '../../../../../components/Button'
import { Flex, Image } from '@chakra-ui/react'

import IconeLove from '../../../../../assets/IconeLove.svg'
import IconeMagoado from '../../../../../assets/IconeMagoado.svg'
import IconeFeliz from '../../../../../assets/IconeFeliz.svg'
import IconePiscada from '../../../../../assets/IconePiscada.svg'
import IconeTriste from '../../../../../assets/IconeTriste.svg'
import { useNavigate } from 'react-router-dom'

interface iDadoTabela {
  id: string
  origem: string
  totalAcoes: number
  totalConcluidas: number
  dataFim: string
  ultimaAvaliacao?: number
  temAcaoAtrasada: boolean
}

interface iTabelaProps {
  slice: number
  dados: iDadoTabela[]
}

export const TabelaEmAndamento: React.FC<iTabelaProps> = ({ dados, slice }) => {
  const nav = useNavigate()
  function UltimaAvaliacao(nota: number): any {
    if (nota === 1) {
      return <Image src={IconeTriste} />
    } else if (nota === 2) {
      return <Image src={IconeMagoado} />
    } else if (nota === 3) {
      return <Image src={IconeFeliz} />
    } else if (nota === 4) {
      return <Image src={IconePiscada} />
    } else {
      return <Image src={IconeLove} />
    }
  }

  return (
    <Container>
      <thead>
        <tr>
          <th>Origem</th>
          <th>Concluídas / <br/> total de ações</th>
          <th>Data final</th>
        </tr>
      </thead>
      <tbody>
        {
          dados.slice(0, slice).map((e, i) => {
            return (
              <tr style={{ color: e.temAcaoAtrasada ? 'var(--Red)' : '' }} key={i}>
                <th>{e.origem}</th>
                <th>{e.totalConcluidas}/{e.totalAcoes}</th>
                <th>{e.dataFim}</th>
                <th>
                  <Flex maxHeight={'2.5rem'}>
                    {e.ultimaAvaliacao && UltimaAvaliacao(e.ultimaAvaliacao) }
                  </Flex>
                </th>
                <th>
                  <Flex gap={'1rem'}>
                    <Button
                      size={'sm'}
                      VarColor='Azul'
                      onClick={() => nav(`/Desempenho/PDI/Avaliacao/${e.id}`)}
                    >Avaliar</Button>

                    <Button
                      size={'sm'}
                      VarColor='Azul'
                      colorScheme={'blueDefault'}
                      onClick={() => nav(`/Desempenho/PDI/Editar/${e.id}`)}
                    >Visualizar</Button>
                  </Flex>
                </th>
              </tr>
            )
          })
        }
      </tbody>
    </Container>
  )
}
